import { Pane } from "components/materials";
import { majorScale } from "helpers/utilities";
import { CurrentFilters } from "./CurrentFilters";
import { FiltersWidget } from "./FiltersWidget";

export function Filters({
  filterConfig,
  filterFields,
  projects,
  setFilterConfig,
}) {
  return (
    <Pane marginLeft={majorScale(2)} display="flex" alignItems="center">
      <FiltersWidget
        dataColumns={filterFields}
        filterBy={setFilterConfig}
        filterConfig={filterConfig}
        items={projects}
        marginRight={majorScale(2)}
      />
      <CurrentFilters
        dataColumns={filterFields}
        filterBy={setFilterConfig}
        filterConfig={filterConfig}
      />
    </Pane>
  );
}
